import { jsx as a, jsxs as c, Fragment as m } from "react/jsx-runtime";
import O from "react";
import { styled as t, css as n } from "styled-components";
import { g as T } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { m as e, a as B } from "../chunks/breakpoints.907eaecd.js";
import { R as F, I as S, a as g } from "../chunks/index.5437e162.js";
import { R as L, H as z } from "../chunks/Heading.2a0f9b41.js";
import { R as k } from "../chunks/Description.be3b00d1.js";
import { R as D, a as v } from "../chunks/index.6d6da1e3.js";
import { R as H, B as _ } from "../chunks/index.b09c00db.js";
import { R as G } from "../chunks/NavBar.71e21263.js";
import { u as j } from "../chunks/useForwardRef.7bf5d172.js";
const o = {
  SLOT: "slot",
  CONFIRM: "confirm",
  CONFIRM_DANGER: "confirm-danger"
};
Object.values(o);
const A = t.div.withConfig({
  displayName: "ModalContainer",
  componentId: "sc-1d07yul-0"
})(["position:fixed;display:flex;justify-content:center;align-items:center;opacity:0;pointer-events:none;top:0;right:0;width:100%;height:100%;overflow:hidden;transition:opacity var(--duration-moderate-01) var(--curve-productive-exit);transition-delay:0.1s;z-index:4;", ";", ""], ({
  $showOverlay: i
}) => i && T, ({
  open: i
}) => i && `   
    transition-duration: var(--duration-slow-01);
    transition-timing-function: var(--curve-productive-entrance);
      pointer-events: auto;
      opacity: 1;
      
  `), E = t.div.withConfig({
  displayName: "Modal",
  componentId: "sc-1d07yul-1"
})(["display:flex;flex-direction:column;box-sizing:border-box;width:50vw;min-width:480px;max-width:720px;min-height:440px;background-color:var(--elements-bg-color-01);border-radius:var(--border-radius-lg);overflow:hidden;opacity:0;transition:transform var(--duration-moderate-02) var(--curve-productive-exit),opacity var(--duration-moderate-01) var(--curve-productive-exit);transform:translateY(20%);", " ", " ", " ", ""], ({
  open: i
}) => i && `
    transition-timing-function: var(--curve-productive-entrance);
    opacity: 1;
    transform: translateY(0);
  `, e.sm(n`
    position: fixed;
    bottom: 0;
    width: 100vw;
    min-width: 320px;
    border-radius: var(--border-radius-none);
    height: 480px;
  `), B.xl(n`
    width: 720px;
  `), ({
  type: i
}) => i !== o.SLOT && `
      height: 400px;
    `), $ = t.div.withConfig({
  displayName: "ModalContent",
  componentId: "sc-1d07yul-2"
})(["display:flex;flex-direction:column;align-items:center;overflow:hidden;padding:var(--spacing-10x) var(--spacing-5x) var(--spacing-5x) var(--spacing-5x);", " ", ""], e.sm(n`
    max-height: 264px;
    padding: var(--spacing-10x) var(--spacing-3x) var(--spacing-3x)
      var(--spacing-3x);
  `), ({
  $type: i
}) => i === o.SLOT && n`
      overflow: hidden;
      padding: var(--spacing-5x);
      ${e.sm(n`
        padding: var(--spacing-3x);
      `)}
    `), U = t(H).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1d07yul-3"
})(["position:absolute !important;top:var(--spacing-3x);right:var(--spacing-3x);", ""], e.sm(n`
    top: var(--spacing-1x);
    right: var(--spacing-1x);
  `)), P = t(F).withConfig({
  displayName: "Icon",
  componentId: "sc-1d07yul-4"
})(["margin-bottom:var(--spacing-3x);"]), Y = t.div.withConfig({
  displayName: "TextContent",
  componentId: "sc-1d07yul-5"
})(["max-width:400px;"]), q = t(L).withConfig({
  displayName: "Heading",
  componentId: "sc-1d07yul-6"
})(["margin-bottom:var(--spacing-1x);text-align:center;"]), J = t(k).withConfig({
  displayName: "Description",
  componentId: "sc-1d07yul-7"
})(["text-align:center;"]), K = t(D).withConfig({
  displayName: "FixedBar",
  componentId: "sc-1d07yul-8"
})(["margin-top:auto;position:absolute;bottom:0;display:flex;width:100%;", ""], ({
  type: i
}) => i === o.CONFIRM_DANGER && n`
      ${e.sm(n`
        > div {
          width: fit-content;
        }
      `)}
      button {
        &:nth-child(1) {
          color: var(--text-label-color);
        }
        &:nth-child(2) {
          background-color: var(--negative-bg-color-03);
          height: var(--spacing-8x);
        }
      }
    `), Q = O.forwardRef(({
  type: i = o.SLOT,
  heading: s,
  description: u,
  icon: x,
  open: r = !1,
  showOverlay: l = !0,
  closeOnOverlayClick: h = !1,
  onClose: d,
  onConfirm: f,
  onCancel: y,
  actionLabel: w,
  cancelLabel: R,
  children: C,
  ...b
}, I) => {
  const p = j(I);
  return /* @__PURE__ */ a(A, { onClick: (N) => {
    const M = N.target;
    l && h && M === p.current && d && d();
  }, ref: p, open: r, $showOverlay: l, "data-testid": "rango-modal", "data-rango-component": "rango-modal", "data-is-rango": !0, ...b, children: /* @__PURE__ */ c(E, { open: r, type: i, autoFocus: r, children: [
    i === o.SLOT ? /* @__PURE__ */ a(G, { heading: i === o.SLOT ? {
      children: s
    } : {
      children: void 0
    }, onClose: d }) : /* @__PURE__ */ a(U, { size: _.LG, icon: "CloseLine", "aria-label": "Fechar", onClick: d }),
    /* @__PURE__ */ a($, { $type: i, autoFocus: r, children: i === o.SLOT ? /* @__PURE__ */ a(m, { children: C }) : /* @__PURE__ */ c(m, { children: [
      /* @__PURE__ */ a(P, { size: S.MD, icon: x, type: i === o.CONFIRM ? g.Positive : g.Negative }),
      /* @__PURE__ */ c(Y, { children: [
        /* @__PURE__ */ a(q, { size: z.SM, children: s }),
        /* @__PURE__ */ a(J, { children: u })
      ] })
    ] }) }),
    /* @__PURE__ */ a(K, { type: i, action: i === o.CONFIRM_DANGER ? v.BUTTON_GROUP : v.BUTTON, labelButtonConfirm: w, labelButtonCancel: R, onConfirm: f, onCancel: y })
  ] }) });
});
Q.displayName = "RangoModal";
export {
  o as ModalType,
  Q as RangoModal
};
